import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a7229c4e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7229c4e')) {
      api.createRecord('a7229c4e', component.options)
    } else {
      api.reload('a7229c4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a7229c4e", function () {
      api.rerender('a7229c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/file/index.vue"
export default component.exports